import { render } from "./PostsList.vue?vue&type=template&id=240142f0&scoped=true"
import script from "./PostsList.vue?vue&type=script&lang=js"
export * from "./PostsList.vue?vue&type=script&lang=js"

import "./PostsList.vue?vue&type=style&index=0&id=240142f0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-240142f0"]])

export default __exports__